import { LoaderCircle } from "lucide-react"
import { cn } from "@/shared/lib/utils"

export function PageLoader({ className }: { className?: string }) {
  return (
    <div className={cn("flex h-full items-center justify-center py-16", className)}>
      <LoaderCircle className="size-6 animate-spin text-muted-foreground" />
    </div>
  )
}
